import _typeof from "@babel/runtime/helpers/typeof";
export function preventDefault(e) {
  e.preventDefault();
}
export function isVideoPlayerContent(video) {
  return _typeof(video) === 'object' && video !== null && video !== undefined && 'src' in video && 'poster' in video;
}